import React, { useState, useEffect, useRef } from "react";
import "./ECommerce.css";
import "../Page.css";
import ListViewGallery from "./GalleryComponents/listView_Gallery";
import AttachmentDetailPopUp from "./GalleryComponents/attachementDetailPopUp";
import { BsFillGrid3X3GapFill } from "react-icons/bs";
import { FaList } from "react-icons/fa6";
import { RxCalendar } from "react-icons/rx";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import nomedia from "../../Assets/nomedia.png"
import loaderGif from '../../Assets/Images/loader-check-three.gif'

export default function MediaLibrary() {
    const [isLoading, setIsLoading] = useState(false);
    const [selectedView, setSelectedView] = useState(0) // 0--> Grid 1 --> for list
    const [mediaList, setMediaList] = useState([]);
    const [searchText, setSearchText] = useState("");
    const [dateRange, setDateRange] = useState([]);
    const [startDate, endDate] = dateRange;
    const [showDateFilter, setShowDateFilter] = useState(false);
    const [showImagePopup, setShowImagePopup] = useState(false)
    const dropdownRef = useRef(null);
    const getImageCleanUrl = (imageUrl) => {
        if (!imageUrl) return '';

        const parts = imageUrl.split('/');
        return parts[parts.length - 1];
    };

    const getCleanImageName = (imageUrl) => {
        if (!imageUrl) return '';

        const parts = imageUrl.split('/');
        const fileName = parts[parts.length - 1];

        // Remove extension
        const nameWithoutExt = fileName.split('.')[0];

        // Remove numeric prefixes and underscores
        const nameParts = nameWithoutExt.split('_');

        // Join only the parts after the numeric prefixes
        const cleanName = nameParts.slice(2).join(' ');

        return cleanName;
    };

    const formatDate = (dateString) => {
        if (!dateString) return '';
        const date = new Date(dateString);
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
        const day = String(date.getDate()).padStart(2, '0');
        const year = date.getFullYear();

        return `${month}-${day}-${year}`;
    };


    const [selectedFileDetails, setSelectedFileDetails] = useState({
        uploadedOn: "",
        uploadedBy: "",
        uploadedTo: "",
        fileName: "",
        fileType: "",
        fileSize: "",
        dimensions: "",
        altText: "",
        title: "",
        description: "",
        imageUrl: ""
    })

    const showPopUpData = (item) => {
        setSelectedFileDetails({
            uploadedOn: formatDate(item.createdAt),
            uploadedBy: "Maaz",
            uploadedTo: "Product",
            fileName: getCleanImageName(item.image_url),
            fileType: "image/" + item.imageType,
            fileSize: `${item.imageSizeKB} KB`,
            dimensions: item.dimensions?.width && item.dimensions?.height
                ? `${item.dimensions.width} x ${item.dimensions.height}`
                : "N/A",
            altText: item.alt_text,
            title: item.title,
            description: item.description,
            imageUrl: item.image_url
        });
        setShowImagePopup(true)
    }



    useEffect(() => {
        const fetchFilteredMedia = () => {
            setIsLoading(true); // Start loader
            let url = `https://fmapi.myfurnituremecca.com/api/v1/media/products/get-fitered?`;

            if (searchText.trim() !== "") {
                url += `name=${encodeURIComponent(searchText.trim())}&`;
            }

            if (startDate && endDate) {
                const formattedStartDate = startDate.toISOString().split("T")[0];
                const formattedEndDate = endDate.toISOString().split("T")[0];
                url += `startDate=${formattedStartDate}&endDate=${formattedEndDate}`;
            }

            fetch(url)
                .then(res => res.json())
                .then(data => {
                    if (data?.media) {
                        setMediaList(data.media);
                    } else {
                        setMediaList([]);
                    }
                })
                .catch(err => console.error("Error fetching media:", err))
                .finally(() => setIsLoading(false)); // Stop loader in all cases
        };

        fetchFilteredMedia();
    }, [searchText, dateRange]);


    const filteredMedia = mediaList;

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setShowDateFilter(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    return (
        <>
            <div className="media_library_main">
                <div className="media_header_lib">
                    <div style={{ display: "flex", gap: "20px" }}>
                        <div className="view_section_media_header">
                            <div className={selectedView === 1 ? "vsm_h_icon active" : "vsm_h_icon"} onClick={() => { setSelectedView(1) }}>
                                <FaList size={25} />
                            </div>
                            <div className={selectedView === 0 ? "vsm_h_icon active" : "vsm_h_icon"} onClick={() => { setSelectedView(0) }}>
                                <BsFillGrid3X3GapFill size={25} />
                            </div>
                        </div>

                        <div className="date_filter_header" ref={dropdownRef}>
                            <div className="from_fh side_fh" onClick={() => setShowDateFilter(!showDateFilter)}>
                                <RxCalendar size={22} />
                                <div className="date_sfh">
                                    <p>From</p>
                                    <span>{startDate ? startDate.toLocaleDateString() : "Select Start Date"}</span>
                                </div>
                            </div>
                            <div className="to_fh side_fh" onClick={() => setShowDateFilter(!showDateFilter)}>
                                <RxCalendar size={22} />
                                <div className="date_sfh">
                                    <p>Till</p>
                                    <span>{endDate ? endDate.toLocaleDateString() : "Select End Date"}</span>
                                </div>
                            </div>

                            {showDateFilter && (
                                <div className="date_filter_dropdown">
                                    <DatePicker
                                        selectsRange
                                        startDate={startDate}
                                        endDate={endDate}
                                        onChange={(update) => setDateRange(update)}
                                        dateFormat="dd/MM/yyyy"
                                        inline
                                    />
                                </div>
                            )}
                        </div>
                        {dateRange?.length > 0 && <button className="filter_btn_vsm" onClick={() => { setDateRange([]) }}>
                            Clear
                        </button>}
                    </div>

                    <div className="search_media_seracher">
                        <p>Search Media</p>
                        <input
                            type="text"
                            placeholder="Search..."
                            className="search_input"
                            value={searchText}
                            onChange={(e) => setSearchText(e.target.value)}
                        />
                    </div>
                </div>

                <div className="media_images_lib">
                    {selectedView === 1 && <div className="gallery_list_header">
                        <div className="image_section_lvgi_head">File</div>
                        <div className="author_detail_lvgi_head">Author
                        </div>
                        <div className="uploaded_to_lvgi_head">Uploaded to
                        </div>
                        <div className="date_lvgi_head">Date
                        </div>
                    </div>}
                    {filteredMedia?.length > 0 ? (
                        selectedView === 0 ? (
                            <div className="gallery_grid">
                                {filteredMedia.map((item, index) => (
                                    <div className="gallery_item" onClick={() => {

                                        // setShowImagePopup(true)
                                        showPopUpData(item)
                                    }} key={item._id}>
                                        <img
                                            src={`https://fmapi.myfurnituremecca.com${item.image_url}`}
                                            alt={item.name}
                                            className="gallery_img"
                                        />
                                        {/* <p className="gallery_img_name">{getCleanImageName(item.image_url)}</p> */}
                                    </div>
                                ))}
                                {(isLoading && filteredMedia.length !== 0) && <div className="overlay_loader_gallery">
                                    <img src={loaderGif} />
                                    <p>Please Wait</p>
                                </div>}
                            </div>
                        ) : (
                            <div className="gallery_list">
                                {filteredMedia.map((item, index) => (
                                    <ListViewGallery
                                        key={index}
                                        name={getCleanImageName(item.image_url)}
                                        name2={getImageCleanUrl(item.image_url)}
                                        image={`https://fmapi.myfurnituremecca.com${item.image_url}`}
                                        product={"Product Name"}
                                        date={formatDate(item.createdAt)}
                                    />
                                ))}
                                {(isLoading && filteredMedia.length !== 0) && <div className="overlay_loader_gallery">
                                    <img src={loaderGif} />
                                    <p>Please Wait</p>
                                </div>}
                            </div>
                        )

                    ) : (filteredMedia?.length === 0 && isLoading) ? (
                        <div className="no_media_found_1">
                            <img src={loaderGif} />
                            <p style={{ color: "#595959" }}>Please Wait</p>
                        </div>) :

                        (<div className="no_media_found_1">
                             <img src={nomedia} alt="" />
                            <p>No media found.</p>
                        </div>
                        )}
                </div>

            </div>
            {showImagePopup && <AttachmentDetailPopUp selectedFileDetails={selectedFileDetails} closeFn={() => { setShowImagePopup(false) }} />}
        </>
    );
}
